<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <v-container class="bordered bg-white mb-4">
          <CalcInputNumber
            :id="nodeId"
            class="mb-4"
            field="cycle_time_part"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            class="mb-4"
            field="number_of_parts_part"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            class="mb-4"
            field="manufacturing_scrap_percentage_part"
            :rules="[required, percents]" />

          <CalcInputNumber
            :id="nodeId"
            class="mb-4"
            field="share_of_the_lot_percentage_part"
            :rules="[required, percents]" />
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { useTranslation } from "i18next-vue";
import { useCommonRules } from "@/validations/common";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";

const { t } = useTranslation();
const { required, percents, positive } = useCommonRules(t);

defineProps({
  nodeId: {
    type: String,
    required: true
  }
});
</script>
